<template>
  <div id="app">
    <Header v-if="showCommon" />
    <router-view class="application" />
    <Footer v-if="showCommon" />
    <ContributionTip v-if="showCommon" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      showCommon: false
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.$route.name !== 'Login') {
        this.getUserInfo(true);
      }
      this.showCommon = this.$route.name !== 'Login';
    }, 300);
  },
  methods: {
    ...mapActions(['getUserInfo']),
  },
  watch: {
    $route(v) {
      this.showCommon = v.name !== 'Login';
    }
  }
};
</script>

<style lang="less">
@import "./assets/reset.less";
</style>
